import { Reveal, Chapter } from "./Reveal";
import { Award, Globe2 } from "lucide-react";

const STATS = [
  { value: "200+", label: "klientu veiksmes stāsti" },
  { value: "208 000", label: "stundu pieredze reklāmas kampaņu pārvaldīšanā" },
  { value: "€919 milj.", label: "mūsu e-komercijas klientu ieņēmumi internetā 2025. gadā (GA4 dati)" },
  { value: "20+", label: "valstis, kurās palīdzam klientiem augt" },
];

export default function Stats() {
  return (
    <section data-testid="stats-section" className="bg-[#003E75] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 md:py-32">
        <Chapter number="05" label="Uzticamība" dark />

        <div className="grid lg:grid-cols-2 gap-16">
          <div>
            <Reveal>
              <h2 className="font-display font-black tracking-tighter leading-[1.02] text-4xl sm:text-5xl lg:text-6xl text-white" data-testid="stats-heading">
                Kāpēc uzticēt auditu{" "}
                <span className="text-white/30">iMarketings.lv?</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1} className="mt-8 space-y-5 text-white/55 text-base leading-relaxed">
              <p className="text-white text-lg font-semibold">Mēs zinām, kā ražot kreatīvus, kas sasniedz mērķi.</p>
              <p>
                iMarketings.lv ir viena no lielākajām un pieredzes bagātākajām digitālā mārketinga
                aģentūrām Latvijā. Mēs strādājam ar skaidru fokusu uz biznesa rezultātu: pārdošanu,
                pieteikumiem, ROAS un CPA.
              </p>
              <p>
                Mūsu komandā kreatīvu izstrāde nav atrauta no reklāmas rezultātiem. Creative komanda
                strādā kopā ar Meta Ads, Google Ads un stratēģijas ekspertiem. Tādēļ baneri un video
                tiek vērtēti ne tikai no dizaina vai video producēšanas perspektīvas, bet arī no
                pārdošanas kampaņu perspektīvas.
              </p>
            </Reveal>

            <div className="mt-10 space-y-4">
              <Reveal delay={0.15}>
                <div className="flex items-center gap-5 rounded-sm border border-white/15 bg-[#002B54] p-6" data-testid="badge-google">
                  <Award className="h-8 w-8 text-[#ED1C27] shrink-0" />
                  <div>
                    <p className="font-display font-bold text-lg tracking-tight text-white">9 gadus pēc kārtas - Google Premier Partner</p>
                    <p className="text-white/45 text-sm">Statuss, ko saņem tikai 3% aģentūru.</p>
                  </div>
                </div>
              </Reveal>
              <Reveal delay={0.2}>
                <div className="flex items-center gap-5 rounded-sm border border-white/15 bg-[#002B54] p-6" data-testid="badge-meta">
                  <Globe2 className="h-8 w-8 text-[#ED1C27] shrink-0" />
                  <div>
                    <p className="font-display font-bold text-lg tracking-tight text-white">#1 Latvijā - Meta Business Partner</p>
                    <p className="text-white/45 text-sm">Pirmā Latvijas aģentūra, kas saņēmusi Meta Business Partner statusu.</p>
                  </div>
                </div>
              </Reveal>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-px bg-white/10 border border-white/10 self-start">
            {STATS.map((s, i) => (
              <Reveal key={i} delay={i * 0.07} className="bg-[#003E75]">
                <div className="p-8 md:p-10 h-full hover:bg-[#002B54] transition-colors duration-300" data-testid={`stat-${i}`}>
                  <p className="font-display font-black tracking-tighter text-4xl md:text-6xl text-white">{s.value}</p>
                  <p className="mt-3 text-white/45 text-sm leading-relaxed">{s.label}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
